<script lang="ts" setup>
import { onMounted, onBeforeUnmount } from 'vue'
import RoomieModal from '@lahaus-roomie/roomie/src/components/RoomieModal/index.vue'
import RoomieOverlay from '@lahaus-roomie/roomie/src/components/RoomieOverlay/index.vue'

import type { Props } from './types'

withDefaults(defineProps<Props>(), {
  title: '',
  position: 'absolute',
  primaryTrackingLhId: undefined,
  secondaryTrackingLhId: undefined,
  closeTrackingLhId: undefined
})
const emit = defineEmits(['close'])

const handleCloseModal = () => {
  emit('close')
}

onMounted(() => {
  document.body.style.overflow = 'hidden'
})

onBeforeUnmount(() => {
  document.body.style.overflow = 'auto'
})
</script>

<script lang="ts">
export default {
  name: 'AppModal'
}
</script>

<template>
  <div
    class="app-modal top-0 left-0 w-full h-full"
    :style="{ position }">
    <RoomieOverlay @overlay-closed="handleCloseModal">
      <RoomieModal
        :title="title"
        description=""
        :is-content="true"
        :style="styleModal"
        :primary-tracking-lh-id="primaryTrackingLhId"
        :secondary-tracking-lh-id="secondaryTrackingLhId"
        :close-tracking-lh-id="closeTrackingLhId"
        class="app-modal-content"
        @modal-closed="handleCloseModal">
        <slot />
      </RoomieModal>
    </RoomieOverlay>
  </div>
</template>

<style lang="scss">
.app-modal {
  & .roomie-modal {
    @apply my-0 self-center;

    &__body {
      @apply overflow-auto;
    }
  }

  #roomie-modal-navigation-button {
    @apply bg-white flex justify-end;

    width: calc(100% - 24px);

    .roomie-button-navigation__icon {
      border: none;
    }
  }
}
</style>
